<div class="container-fluid">
  <div class="styles-body">
    <div class="panel-body content-body-pages">
      <div class="page-header">
        <div class="header-content">
          <div class="header-icon">
            <mat-icon>category</mat-icon>
          </div>
          <div class="header-text">
            <h1 class="page-title">{{ 'MenuManagement' | translate }}</h1>
            <p>{{ 'ManageCategoriesAndProducts' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="filters-section">
        <app-frontend-filter (onFiltersChanged)="onFiltersChanged($event)"
                             [filters]="allFilters">
        </app-frontend-filter>
      </div>
      <div class="categories-management-container">
        <div class="left-section">
          <div class="branch-section">
            <div class="section-title">
              <mat-icon>store</mat-icon>
              <span>{{ 'SelectBranch' | translate }}</span>
            </div>
            <div class="branch-container">
              <div class="branch-grid">
                @if (isLoadingBranches) {
                  <div class="loading-branches">
                    <div class="loading-spinner">
                      <mat-icon>refresh</mat-icon>
                    </div>
                    <p>{{ 'LoadingBranches' | translate }}</p>
                  </div>
                } @else if (branches && branches.length > 0) {
                  @for (branch of branches; track branch.BusinessId) {
                    <div (click)="onBranchClick(branch)"
                         [ngClass]="{'selected': isBranchSelected(branch)}"
                         class="branch-item">
                      <div class="branch-icon">
                        <mat-icon>store</mat-icon>
                      </div>
                      <div class="branch-info">
                        <h4 class="branch-title">{{ branch.Title }}</h4>
                        @if (branch.Address) {
                          <p class="branch-address">{{ branch.Address }}</p>
                        }
                      </div>
                      <div class="branch-selection-indicator">
                        <img [src]="isBranchSelected(branch) ? '/icons/tick-circle.svg' : '/icons/circle.svg'"
                             alt="selection">
                      </div>
                    </div>
                  }
                } @else {
                  <div class="no-branches">
                    <mat-icon>store</mat-icon>
                    <p>{{ 'NoBranchesFound' | translate }}</p>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="categories-section">
            <div class="section-title">
              <span>{{ 'Categories' | translate }}</span>
            </div>

            @if (isLoadingCategories) {
              <div class="loading-categories">
                <div class="loading-spinner">
                  <mat-icon>refresh</mat-icon>
                </div>
                <p>{{ 'LoadingCategories' | translate }}</p>
              </div>
            } @else {
              <div class="categories-grid">
                <div (click)="onCreateCategoryClicked()"
                     class="category-item add-category-item">
                  <div class="category-icon">
                    <mat-icon>add</mat-icon>
                  </div>
                  <div class="category-title">{{ 'AddCategory' | translate }}</div>
                </div>

                @for (category of categories; track category.CategoryId) {
                  <div [ngClass]="{'selected': selectedCategory.CategoryId === category.CategoryId}"
                       class="category-item">
                    <div (click)="onCategoryClick(category)"
                         class="category-content">
                      <div class="category-icon">
                        <img [src]="formatImage('', category?.Icon)"
                             alt="category"
                             height="40"
                             width="40">
                      </div>
                      <div class="category-info">
                        <div class="category-title">{{ category.Title }}</div>
                        <div class="category-count">{{ category.ServiceCount }} {{ 'Products' | translate }}</div>
                      </div>
                    </div>
                    <div class="category-actions">
                      <button (click)="onUpdateCategoryClicked(category); $event.stopPropagation()"
                              class="action-btn edit-btn">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button (click)="onDeleteCategoryClicked(category); $event.stopPropagation()"
                              class="action-btn delete-btn">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="right-section">
          <div class="products-section">
            <div class="section-title">
              <span>{{ getSelectedCategoryTitle() }}</span>
              @if (products.length > 0) {
                <span class="product-count">({{ selectedCategory.ServiceCount }} {{ 'Products' | translate }})</span>
              }
            </div>

            @if (isLoadingProducts) {
              <div class="loading-products">
                <div class="loading-spinner">
                  <mat-icon>refresh</mat-icon>
                </div>
                <p>{{ 'LoadingProducts' | translate }}</p>
              </div>
            } @else {
              <div class="products-grid">
                @if (selectedCategory) {
                  <div (click)="onCreateProductClicked()"
                       class="product-card add-product-card">
                    <div class="product-image">
                      <mat-icon>add</mat-icon>
                    </div>
                    <div class="product-info">
                      <div class="product-header">
                        <h4 class="product-title">{{ 'AddService' | translate }}</h4>
                      </div>
                      <div class="product-description">
                        {{ 'AddNewServiceToCategory' | translate }}
                      </div>
                    </div>
                  </div>
                }
                @if (products.length > 0) {
                  @for (product of products; track product.ServiceId) {
                    <div class="product-card">
                      <div class="product-image">
                        <img [src]="formatImage('x', product?.Images[0])"
                             alt="product">
                      </div>
                      <div class="product-info">
                        <div class="product-header">
                          <h4 class="product-title">{{ product.Title }}</h4>
                        </div>

                        @if (product.Description) {
                          <p [innerHTML]="domSanitizer.bypassSecurityTrustHtml(product.Description)"
                             class="product-description"></p>
                        }
                        @if (product.Features && product.Features.length > 0) {
                          <div class="product-features">
                            <h5>{{ 'Features' | translate }}</h5>
                            <ul>
                              @for (feature of product.Features; track feature) {
                                <li>{{ feature }}</li>
                              }
                            </ul>
                          </div>
                        }

                        <div class="product-spacer"></div>

                        @if (checkServicePrice(product.ServiceId)) {
                          <div class="product-price-rating">
                            <div class="price-section">
                              @if (getServicePrice(product.ServiceId)?.NewPrice && getServicePrice(product.ServiceId)?.NewPrice !== getServicePrice(product.ServiceId)?.Price) {
                                <div class="price-row">
                                  <span
                                    class="old-price">{{ getServicePrice(product.ServiceId)?.Price | number:'1.0-0' }}
                                    ریال</span>
                                </div>
                                <div class="price-row">
                                <span
                                  class="new-price">{{ getServicePrice(product.ServiceId)?.NewPrice | number:'1.0-0' }}
                                  ریال</span>
                                </div>
                              } @else {
                                <div class="price-row">
                                  <span class="price">{{ getServicePrice(product.ServiceId)?.Price | number:'1.0-0' }}
                                    ریال</span>
                                </div>
                              }
                            </div>
                            <div class="rating-section">
                              <div class="product-rating">
                                <span class="rate-text">{{ product.Rate || 0 | number:'1.1-1' }}</span>
                                <img alt="rating"
                                     height="16"
                                     src="/icons/star.svg"
                                     width="16">
                              </div>
                            </div>
                          </div>
                          <div class="mb-3 d-flex justify-content-between">
                              <span>
                                {{ 'RemainedCapacity' | translate }}
                                : {{ getServicePriceRemainedCapacity(product.ServiceId, getServicePrice(product.ServiceId)?.ServicePriceId) }}
                              </span>
                            <span>
                                {{ 'Status' | translate }}
                              : {{ product.IsActive ? 'فعال' : 'غیرفعال' }}
                              </span>
                          </div>
                        } @else {
                          <div class="price-section mb-3">
                              <span
                                class="new-price">{{ 'ThisBranchHasNotServicePrice' | translate }}</span>
                          </div>
                        }

                        <div class="product-actions">
                          <button (click)="onManageFeaturesClicked(product)"
                                  class="action-btn feature-btn">
                            <mat-icon>list</mat-icon>
                            <span>{{ 'Features' | translate }}</span>
                          </button>
                          <button (click)="onUpdateProductClicked(product)"
                                  class="action-btn edit-btn">
                            <mat-icon>edit</mat-icon>
                            <span>{{ 'Edit' | translate }}</span>
                          </button>
                          <button (click)="onDeleteProductClicked(product)"
                                  class="action-btn delete-btn">
                            <mat-icon>delete</mat-icon>
                            <span>{{ 'Delete' | translate }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  }
                } @else if (selectedCategory) {
                  <div class="no-products">
                    <div class="no-products-icon">
                      <img alt="no products"
                           height="80"
                           src="/icons/empty-list.svg"
                           width="80">
                    </div>
                    <div class="no-products-content">
                      <h4>{{ 'NoProductsFound' | translate }}</h4>
                      <p>{{ 'AddFirstProductToCategory' | translate }}</p>
                    </div>
                  </div>
                } @else {
                  <div class="no-category-selected">
                    <div class="no-category-icon">
                      <mat-icon>category</mat-icon>
                    </div>
                    <div class="no-category-content">
                      <h4>{{ 'SelectCategory' | translate }}</h4>
                      <p>{{ 'SelectCategoryToViewProducts' | translate }}</p>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
